// client/src/locales/en

const en = {
  translation: {
    publication: {
      subjects: "All subjects", 
      sort: "Sort", 
      date_newest: "Sort on date (Newest)", 
      date_oldest: "Sort on date (Oldest)", 
      title_a_z: "Sort on title (A-Z)", 
      title_z_a: "Sort on title (Z-A)" ,
      nadaa: "No event planned for now.",
      search_placeholder: "Search on title or author",
      date_from: "From",
      date_to: "To",
      search_button: "Show results",
      no_results: "No publication found."
    },
    shop: {
      order: "您的訂單", 
      place_order: "請求材料", 
      filter: "所有主題", 
      download: "下載", 
      prev: "上一步",
      form: "地址數據", 
      max: "注文可能な最大数に達しました」",
      aside_title: "你的訂單" , 
      selected_items: "精選產品",
      thanks: "Thanks",
      form_submit: '提交',
    },
    form: {
      form_submit: '提交',
      make_a_choice: 'Select an option',
    },
    general: {
      readMore: 'Read more',
      loading: 'Loading',
      close: 'Close',
      disclaimer: '仅供健康专业人士使用', 
    },
    blocks: {
      imageContainer: {
        error: 'Error loading image'
      },
      mapBlock: {
        visitWebsite: 'Visit website',
        map: 'Map',
        list: 'List',
      },
    },
    searchbar: {
      label: '你要買什麼',
      placeholder: '示例：牛奶價格',
    },
    header: {
      language: 'local institutes: ',
    },
    regionSwitch: {
      title: "FrieslandCampina, your global dairy partner",
      description: "We are a worldwide dairy cooperation, operating in more than 50 countries",
      language: "Global"
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Terms & Conditions',
      },
      follow_us: 'Follow us',
    },
    404: {
      title: "Sorry, we can't find the page you're looking for",
      description:
        "It seems like the page doesn't exist (anymore) or perhaps is moved. Ofcourse you can always go back to our homepage.",
      link: '/',
      homepage: 'To homepage',
    },
    cookiebar: {
      title: 'Welcome!',
      description:
        "Probably you're already familiair with companies who are settings cookies on your desktop, tablet or phone. Friesland Campina is also using cookies and you can choose which ones.",
      accept: 'Accept',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'No, decline',
      statement: 'Cookie statement',
      missing: 'You need to enable our cookies to view this video.',
      settings: "Cookie设置"
    },
    searchResults: {
      title: '你搜索過',
      noSearchTerm: '您尚未輸入搜索詞',
      types: {
        article: "Article",
        page: 'Page',
        news: 'News',
        story: 'Story',
        webinar: "Webinar",
        conference: "Conference",
        events: "Event", 
      },
      noResults: '未找到結果，請使用以下提示重試',
      noResultsTips: {
        spelling: '檢查你的拼寫',
        describe: '以不同的方式描述您的搜索',
        shorter: '縮短搜索時間',
      },
    },
    filter: {
      noResults: 'There are no results found when filtering on this category. Please select a different category or click <a href="/frieslandcampina-news/">here</a> to go to the news overview.'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
    },
    show_button: {
      more: 'Show more',
      less: 'Show less'
    },
    share_link: {
      title: 'Share on'
    },
    news: {
      categories: 'Categories:',
    },
    story: {
      categories: 'Categories:',
    },
    filters: {
      filter_on: 'Filter on:',
      category: 'Category',
      all_categories: 'All categories',
      year: 'Year',
      all_years: 'All years',
    },
    formMessage: 'Checking...',
    highlights: {
      title: 'Today at FrieslandCampina',
      footer_copy: 'Find out what else is going on at FrieslandCampina:',
      link_copy: 'Visit our newsroom',
      link_url: "/frieslandcampina-news/"
    },
    certificate:{
      download: "Click here to download your certificate",
      find_download: "You will find the certificate in the download folder"
    }
  },
}

export default en;
